import React from 'react';

import { PrintedRanking } from 'utils/rankings/rankingHelpers';
import RankingsTemplateComponent, {
  Ranking,
  RankingsTemplateConfig
} from '../templates/RankingsTemplateComponent';
import { CommonLayoutPreviewProps } from './CommonLayoutPreviewProps';
import scalePreview from './scale-preview';

interface RankingsPreviewComponentProps extends CommonLayoutPreviewProps {
  config: RankingsTemplateConfig;

  rankings?: Ranking[] | PrintedRanking[];
}

export class RankingsPreviewComponent extends React.Component<
  RankingsPreviewComponentProps
> {
  shouldComponentUpdate() {
    // preview will be forced to redraw on config update only
    return false;
  }

  generateRankings(): Ranking[] {
    return [
      {
        id: 1,
        title: 'Verwirrendstes Tafelbild',
        contestants: ['Herr Kohl', 'Frau Neustadt', 'Frau Osterhagen'],
        renderOverflow: false
      },
      {
        id: 2,
        title: 'Größte Handyabnahmegefahr',
        contestants: ['Herr Neudorf', 'Frau Pfaff', 'Herr Fisher'],
        renderOverflow: false
      },
      {
        id: 3,
        title: 'Wer kann nicht ohne Beamer?',
        contestants: ['Frau Baumgartner', 'Herr Roth', 'Herr Eiffel'],
        renderOverflow: false
      },
      {
        id: 4,
        title: 'Lustigste/r Lehrer/in',
        contestants: ['Frau Pfaff', 'Herr Kohl', 'Herr Fisher'],
        renderOverflow: false
      },
      {
        id: 5,
        title: 'Coolste Sprüche',
        contestants: ['Frau Strauss', 'Herr Saenger', 'Frau Eisenhower'],
        renderOverflow: false
      },
      {
        id: 6,
        title: 'Individuellster Kleidungsstil',
        contestants: ['Herr Roth', 'Herr Trommler', 'Frau Pfaff'],
        renderOverflow: false
      },
      {
        id: 7,
        title: 'Größte Allgemeinbildung',
        contestants: ['Herr Fisher', 'Frau Baumgartner', 'Frau Neustadt'],
        renderOverflow: false
      },
      {
        id: 8,
        title: 'Medienlegastheniker',
        contestants: ['Herr Saenger', 'Herr Kohl', 'Herr Eiffel'],
        renderOverflow: false
      }
    ];
  }

  render() {
    const {
      print,
      config,
      colors,
      pageHeaderStyle,
      sectionHeaderStyle,
      background,
      start,
      scaled,
      chapter,
      title,
      rankings
    } = this.props;

    return (
      <RankingsTemplateComponent
        print={print}
        config={config}
        colors={colors || chapter?.color_scheme?.templateColors || []}
        pageHeaderStyle={pageHeaderStyle || chapter?.font?.pageHeaderStyle}
        sectionHeaderStyle={
          sectionHeaderStyle || chapter?.font?.sectionHeaderStyle
        }
        background={
          background ||
          (chapter?.background?.id || '') +
            (chapter?.background?.extension || '') ||
          undefined
        }
        startPosition={start || 'left'}
        startPage={this.props.startPage || 1}
        render={
          !scaled ? undefined : (content: any, key: any) => scalePreview(content, key)
        }
        title={title || chapter?.title}
        rankings={rankings || this.generateRankings()}
        chapterId={chapter?.id}
      />
    );
  }
}

export default RankingsPreviewComponent;
